// for now to genereate referenceid when create submission
//This is a utility class for string operations
export const StringUtils = {
  //This function generates a random UUIDv4 string
  generateUUID: () => {
    // Pattern for generating UUIDv4
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
};

export default StringUtils;
